import { dataMember, required, typedArray } from 'santee-dcts';

export class UploadedFileResponse {
    @dataMember()
    @required({ nullable: true })
    public fileName: string;

    @dataMember()
    @required()
    public isValid: boolean;

    @dataMember()
    @required()
    @typedArray(String)
    public errorMessages: string[];
}

export enum UploadResponseType {
    ErrorMessage = 'ErrorMessage',
    InvalidFiles = 'InvalidFiles',
    InvalidDocumentMetadata = 'InvalidDocumentMetadata',
    DocumentFolderMissing = 'DocumentFolderMissing'
}

export class UploadedFilesResponse {
    @dataMember()
    @required()
    public responseType: UploadResponseType;

    @dataMember()
    @required()
    @typedArray(UploadedFileResponse)
    public result: UploadedFileResponse[];
}

export class UploadErrorDescription {
    @dataMember()
    @required()
    public message: string;

    @dataMember()
    @required()
    @typedArray(String)
    public details: string[];
}

export class InvalidDocumentMetadataResponse {
    @dataMember()
    @required()    
    public responseType: UploadResponseType;

    @dataMember()
    @required()
    public result: UploadErrorDescription;
}

export function isUploadedFilesResponse(response: any): response is UploadedFilesResponse {
    return response && (response as UploadedFilesResponse).responseType === UploadResponseType.InvalidFiles;
}

export function isInvalidDocumentMetadataResponse(response: any): response is InvalidDocumentMetadataResponse {
    return response && (response as InvalidDocumentMetadataResponse).responseType === UploadResponseType.InvalidDocumentMetadata;
}

export function isDocumentFolderMissingResponse(response: any): response is UploadedFilesResponse {
    return response && (response as UploadedFilesResponse).responseType === UploadResponseType.DocumentFolderMissing;
}